import styled from 'styled-components';

const CallToActionStyle = styled.section`
	--padTB: var(--sp10x);
	--distanceTB: var(--sp22x);
	--btnMarginT: var(--sp7x);

	--sizeFirstLottie: 75%;
	--sizeSecondLottie: 79%;

	background-color: var(--green1000);
	padding: var(--padTB) 0;
	position: relative;
	overflow: hidden;

	#svg-image {
		width: 100%;
		height: 100%;
	}

	.call-to-text-wrapper {
		height: 100%;
		display: flex;
		flex-direction: column;
		align-items: center;
		text-align: center;
		justify-content: center;
		padding: var(--distanceTB) 0;

		.button-wrapper {
			margin-top: var(--btnMarginT);
		}
	}

	.lottie-wrap {
		display: flex;
		align-items: flex-end;
		width: 100% !important;
		height: 100% !important;

		.second-lottie-wrap,
		.first-lottie-wrap {
			width: var(--sizeFirstLottie);
		}

		&.lottie-wrap-2 {
			align-items: flex-start;
			justify-content: flex-end;
			position: relative;
			top: 0;
		}
	}

	.lottie-first {
		display: flex;
		width: 100% !important;
		height: 100% !important;
		width: 100% !important;

		svg {
			width: 100% !important;
			height: 100% !important;
		}
	}

	.lottie-second {
		display: flex;
		width: 100% !important;
	}

	//! 1920 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeXLMin}) {
		--padTB: var(--sp8x);
		--distanceTB: var(--sp19x);
		--btnMarginT: var(--sp5x);

		--sizeFirstLottie: 77%;
		--sizeSecondLottie: 80%;
	}

	//! 1536 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeLMin}) {
		--padTB: var(--sp6x);
		--distanceTB: var(--sp11x);
		--btnMarginT: var(--sp4x);

		--sizeFirstLottie: 76%;
		--sizeSecondLottie: 80%;
	}

	//! 1366 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeMMin}) {
		--padTB: var(--sp5x);
		--distanceTB: var(--sp10x);
	}

	//! 1280 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeSMin}) {
		--distanceTB: var(--sp12x);
	}

	//! 1024 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeMin}) {
		--padTB: var(--sp4x);
		--distanceTB: var(--sp8x);
		--btnMarginT: var(--sp3x);

		--sizeFirstLottie: 76%;
		--sizeSecondLottie: 77%;
	}

	//! 768 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeXMin}) {
		--padTB: var(--sp4x);
		--distanceTB: var(--sp2x);

		--sizeFirstLottie: 78%;
		--sizeSecondLottie: 81%;
	}

	//! Mobile */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeSMin}) {
		--padTB: var(--sp4x);
		--distanceTB: var(--sp2x);

		--sizeFirstLottie: 38.6%;
		--sizeSecondLottie: 56%;

		.row {
			flex-direction: column-reverse;
		}
	}
`;

export default CallToActionStyle;
